"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPlayerBet = void 0;
class SetPlayerBet {
    constructor(betAmount, playerId) {
        this.betAmount = betAmount;
        this.playerId = playerId;
    }
    execute(playerManager, _blackjackState, _instant) {
        const player = playerManager.playerFromId(this.playerId);
        player.setBetAmount(this.betAmount);
    }
}
exports.SetPlayerBet = SetPlayerBet;
